import * as actionTypes from './actionTypes';

export function openResidentDrawer() {
  return dispatch => {
    return dispatch({ type: actionTypes.OPEN_RESIDENT_DRAWER });
  };
}

export function closeResidentDrawer() {
  return dispatch => {
    return dispatch({ type: actionTypes.CLOSE_RESIDENT_DRAWER });
  };
}

export function setLoading(loading) {
  return dispatch => {
    return dispatch({ type: actionTypes.LOADING, loading });
  };
}

export function showInvitedDrawer() {
  return dispatch => {
    return dispatch({ type: actionTypes.SHOW_INVITED_DRAWER, show: true });
  };
}

export function hideInvitedDrawer() {
  return dispatch => {
    return dispatch({ type: actionTypes.SHOW_INVITED_DRAWER, show: false });
  };
}

export function showOptOutResident() {
  return dispatch => {
    return dispatch({ type: actionTypes.SHOW_OPT_OUT_RESIDENT, show: true });
  };
}

export function hideOptOutResident() {
  return dispatch => {
    return dispatch({ type: actionTypes.SHOW_OPT_OUT_RESIDENT, show: false });
  };
}

export function showPasswordReset() {
  return dispatch => {
    return dispatch({ type: actionTypes.SHOW_PASSWORD_RESET, show: true });
  };
}

export function hidePasswordReset() {
  return dispatch => {
    return dispatch({ type: actionTypes.SHOW_PASSWORD_RESET, show: false });
  };
}

export function showDeleteDrawer() {
  return dispatch => {
    return dispatch({ type: actionTypes.SHOW_DELETE_DRAWER, show: true });
  };
}

export function hideDeleteDrawer() {
  return dispatch => {
    return dispatch({ type: actionTypes.SHOW_DELETE_DRAWER, show: false });
  };
}
